(ns hai.admin-ui.users.groups.create
  "User groups create page"
  (:require
   [field :as-alias field]
   [hai-model.model :as model]
   [hai.ui.components :as c]
   [hai.ui.components.form.core :as form]
   [hai.ui.components.form.input :as input]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.components.form :as form-old]
   [hai.web-app.layout :as layout]
   [lambdaisland.ornament :as o]))

(o/defstyled render :div
  :flex :flex-col :gap-3
  :w-100
  [:.buttons :flex :flex-row :gap-3]
  ([{:form/keys [fields valid? on-submit submitting?] :as form-props}]
   (let [{:group/keys [display-name description]} fields]
     [:<>
      [:div
       [form/label display-name]
       [input/field display-name]
       ]
      [:div
       [form/label description]
       [input/field description]]
      [:div.buttons
       [c/Button
        {:disabled (or (not valid?)
                       submitting?)
         :on-click on-submit
         :size "2"}
        "Create"]
       [c/Button
        {:on-click (fn [_] (>e [:routing/navigate [:user/groups]]))
         :disabled submitting?
         :size "2"
         :color "crimson"
         :variant "outline"}
        "Cancel"]]])))

(o/defstyled user-form form-old/form
  ([]
   [form/component
    {:id ::form
     :render render
     :schema model/Organisation
     :initial-value {:group/uuid (random-uuid)
                     :group/type :group.type/organisation}
     :on-submit (fn [group]
                  (>e [:resolve [(list 'group/create group)]
                       ;; TODO form validation and error states
                       {:on-success-fx [[:dispatch [:form/submitted ::form]]
                                        [:dispatch [:routing/navigate [:user/groups]]]]}]))
     }]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Create Organisation or Team"]]
   [user-form]
   [c/Text [:em "Users are added after creation"]]
   ;; TODO doesn't work on non-existing groups
   ;; [components/group-members-table {:group/uuid (random-uuid)
   ;;                                  :user.entity/permissions [:permission.type/admin]}]
   ])

(defn routes
  []
  [["/create"
    {:name :user.groups/create
     :view page}]])
